import fetchAPI from '../../../utils/fetchAPI';

type TParams = {
  email: string;
  recaptchaToken: string;
  xsrfToken: string;
};

export default function resetPassword({ email, recaptchaToken, xsrfToken }: TParams): Promise<any> {
  return fetchAPI({
    method: 'POST',
    url: '/identity/v2/api/reset-password',
    xsrfToken,
    payload: { email, recaptchaToken },
  });
}
